window.afterAngularAppLoad = function() {
  $(document).tooltip({selector: '[data-toggle="tooltip"]'});
  $(document).on('show.bs.tooltip', function () {
    $('.tooltip').remove();
  })
  $(document).popover({selector: '[data-toggle="popover"]'});
};